import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideos"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V4.5H4V3ZM2 5.5H22V21H2V5.5ZM10 9.5L15 13.25L10 17V9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideos;
